import React from 'react';

const WatchlistItemFormModal = React.lazy(() => import('../components/FormModal'));
const watchlistItemModalRegistry = {
    personalize_watchlistItemId: WatchlistItemFormModal
};
export default watchlistItemModalRegistry;
